export default __webpack_public_path__ + "static/media/neill-kumar.e75e72b8.jpg";